import axios from 'axios'
import { get, post, del,getfile } from '@/http/request'
import { HOST } from '@/http/config'

// 列表
export function getElevatorlist(params) {
  return get(`${HOST}basis-elevator/list`, params)
}
// 根据id删除
export function delElevator(params) {
  return del(`${HOST}basis-elevator/delete`, params)
}
// 详情
export function getElevatorDetails(params) {
  return get(`${HOST}basis-elevator/get`, params)
}
// 新增
export function saveElevator(params) {
  return post(`${HOST}basis-elevator/save`, params)
}
// 修改
export function updateElevator(params) {
  return post(`${HOST}basis-elevator/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-elevator-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-elevator-history/get`, params)
}
// 导出
export function Export(params) {
  return getfile(`${HOST}basis-elevator/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/specialEquipElevator/api.js